import { AxiosResponse } from 'axios';
import { userApi } from 'entities/user';
import { getToastMessage, notifyText } from 'shared';
import { error, request, success } from 'shared/api';
import { call, put, takeLatest } from 'typed-redux-saga';

import { userActions } from '..';

export function* getIsKycApprovedSaga({ type, payload: { address } }: ReturnType<typeof userActions.getIsKycApproved>) {
  yield put(request(type));

  try {
    const {
      data: { isKycApproved },
    } = yield* call(userApi.getIsKycApproved, address);

    yield put(
      userActions.updateUserState({
        isKycApproved,
      }),
    );

    getToastMessage('success', notifyText.wallet.connect.success(address));

    yield put(success(type));
  } catch (err) {
    console.log(err);
    yield put(error(type, err));
    const badResponseAxiosError = (err as Error).cause as AxiosResponse;
    getToastMessage('error', badResponseAxiosError?.data?.detail || notifyText.wallet.connect.error.defaultError);
    yield put(userActions.disconnectWalletState());
  }
}

export default function* listener() {
  yield takeLatest(userActions.getIsKycApproved.type, getIsKycApprovedSaga);
}
